import z from 'zod';

const phoneRegex = new RegExp(/^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/);

export const contactSchema = z.object({
    name: z.string().min(2, 'nameMustBeLonger'),
    email: z.string().email('invalidEmail'),
    phone: z.string().regex(phoneRegex, 'invalidPhoneNumber').optional(),
    topic: z.string().optional(),
    message: z.string().optional(),
});

export const subscribeSchema = z.object({
    firstName: z.string().min(2, 'nameMustBeLonger'),
    lastName: z.string().min(2, 'lastNameMustBeLonger'),
    email: z.string().email('invalidEmail'),
});

export const volunteerSchema = z.object({
    name: z.string().min(2, 'nameMustBeLonger'),
    lastName: z.string().min(2, 'lastNameMustBeLonger'),
    email: z.string().email('invalidEmail'),
    streetAddress: z.string().min(2, 'streetAddressMustBeLonger'),
    city: z.string().min(2, 'cityMustBeLonger'),
    province: z.string().min(2, 'provinceMustBeLonger'),
    postalCode: z.string().min(2, 'postalCodeMustBeLonger'),
    country: z.string().min(2, 'countryMustBeLonger'),
    phone: z.string().regex(phoneRegex, 'invalidPhoneNumber'),
    occupation: z.string().optional(),
    language: z.string().optional(),
    additionalLanguages: z.string().optional(),
    yourSkills: z.string().optional(),
    availability: z.string().optional(),
    otherAvailabilities: z.string().optional(),
    previousVolunteer: z.preprocess((value) => value === 'on', z.boolean()).optional(),
    whyWouldYouLike: z.string().optional(),
    isThereAnything: z.string().optional(),
    receiveNewsletter: z.preprocess((value) => value === 'on', z.boolean()).optional(),
});

export type Contact = z.infer<typeof contactSchema>;
export type Subscribe = z.infer<typeof subscribeSchema>;
export type Volunteer = z.infer<typeof volunteerSchema>;
